import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-score-deterioration-modal',
    templateUrl: './score-deterioration-modal.component.html',
    styleUrls: ['./score-deterioration-modal.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ScoreDeteriorationModalComponent implements OnInit {
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    public matDialogRef: MatDialogRef<ScoreDeteriorationModalComponent>,
  ) { }

  ngOnInit(): void {
  }

  close() {
    this.matDialogRef.close();
  }

}
